import { Injectable } from '@angular/core';
import { WindowRef } from '@spartacus/core';
import { Observable, ReplaySubject, take } from 'rxjs';
import { SmartCaptchaGlobalObject, SmartCaptchaInitData } from './smart-captcha.model';

@Injectable({
  providedIn: 'root',
})
export class SmartCaptchaInjectorService {
  private globalFnName = '__onSmartCaptchaReady';
  private isInitialized = false;
  private smartCaptcha$ = new ReplaySubject<SmartCaptchaInitData>(1);

  constructor(private windowRef: WindowRef) {}

  init(): Observable<SmartCaptchaInitData> {
    if (this.windowRef.isBrowser() && !this.isInitialized) {
      this.isInitialized = true;
      this.mountGlobalHandler();
      this.injectScript();
    }

    return this.smartCaptcha$.asObservable().pipe(take(1));
  }

  private mountGlobalHandler(): void {
    Object.defineProperty(this.windowRef.nativeWindow, this.globalFnName, {
      value: () => {
        if (this.windowRef.nativeWindow?.smartCaptcha) {
          this.smartCaptcha$.next({
            globalObject: this.windowRef.nativeWindow.smartCaptcha,
          });
        }
      },
    });
  }

  private injectScript(): void {
    const script = this.windowRef.document.createElement('script');

    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.src = `https://smartcaptcha.yandexcloud.net/captcha.js?render=onload&onload=${this.globalFnName}`;

    this.windowRef.document.head.appendChild(script);
  }
}

declare global {
  interface Window {
    smartCaptcha: SmartCaptchaGlobalObject;
  }
}
